<!--
 * @Description: frontUploadFile文件上传组件--样式重写
 * @Author: fal
 * @FilePath: \pc.ui\src\project\components\frontUploadFile.vue
 * @LastEditTime: 2025-03-06 17:57:21
-->
<template>
  <div class="flex" style="width: 100%">
    <el-upload
      v-show="!(limit && imgs.length == limit)"
      class="new-front-uploader"
      :action="url + '/collective/file/upload'"
      :auto-upload="false"
      :show-file-list="false"
      :multiple="multiple"
      v-loading="loading"
      :on-change="onFileChange"
      :on-remove="delImg"
      :before-upload="beforeUpload"
    >
      <el-button size="small" class="upload-btn" type="primary" icon="el-icon-upload2">资料上传</el-button>
    </el-upload>
    <span v-if="imgs.length > 0" class="img-list">
      <span v-for="(item, index) in imgs" :key="index" class="img-item">
        {{ item.name }}
        <i class="el-icon-close" @click="delImg(item)"></i>
      </span>
    </span>
  </div>
</template>

<script>
export default {
  data() {
    return {
      imageUrl: '',
      url: window.location.origin,
      imgs: [],
      loading: false,
    };
  },
  props: {
    close: {
      type: Boolean,
      default: false,
    },
    list: {
      type: Array,
      default: () => [],
    },
    limit: {
      type: Number,
      default: 0,
    },
    // 文件是否不换行
    noWrap: {
      type: Boolean,
      default: false,
    },
    // 文件不换行时，显示n个后显示文件总数量
    showNum: {
      type: Number,
      default: 0,
    },
    allowedTypes: {
      type: Array,
      default: () => [],
    },
    multiple: {
      type: Boolean,
      default: false,
    },
  },
  watch: {
    close(val) {
      if (val) {
        this.imgs = [];
      }
    },
    list: {
      handler(val) {
        this.imgs = [];
        if (val.length) {
          this.imgs = [];
          val.forEach((item) => {
            let obj = {
              name: item.name,
              url: item.url,
            };
            if (item.url.indexOf('png') > -1 || item.url.indexOf('jpg') > -1 || item.url.indexOf('jpeg') > -1 || item.url.indexOf('gif') > -1) {
              obj.type = 'image';
              this.imgs.push(obj);
            } else if (item.url.indexOf('mp4') > -1) {
              obj.type = 'video';
              this.imgs.push(obj);
            } else if (item.url.indexOf('pdf') > -1) {
              obj.type = 'pdf';
              this.imgs.push(obj);
            } else if (item.url.indexOf('docx') > -1) {
              obj.type = 'docx';
              this.imgs.push(obj);
            } else if (item.url.indexOf('doc') > -1) {
              obj.type = 'doc';
              this.imgs.push(obj);
            } else if (item.url.indexOf('xls') > -1) {
              obj.type = 'xls';
              this.imgs.push(obj);
            } else if (item.url.indexOf('xlsx') > -1) {
              obj.type = 'xlsx';
              this.imgs.push(obj);
            } else if (item.url.indexOf('txt') > -1) {
              obj.type = 'txt';
              this.imgs.push(obj);
            } else if (item.url.indexOf('zip') > -1) {
              obj.type = 'zip';
              this.imgs.push(obj);
            } else if (item.url.indexOf('rar') > -1) {
              obj.type = 'rar';
              this.imgs.push(obj);
            } else if (item.url.indexOf('dwg') > -1) {
              obj.type = 'dwg';
              this.imgs.push(obj);
            } else {
              this.imgs.push(obj);
            }
          });
        }
      },
      deep: true,
      immediate: true,
    },
  },
  methods: {
    // 删除文件
    delImg(item, index) {
      item.index = index;
      this.$deleteFile(this, item.url);
      this.$emit('fileDel', item);
      this.imgs.splice(index, 1);
    },
    // 文件校验
    beforeUpload(file) {
      // 获取文件后缀名
      const fileExtension = file.name.split('.').pop().toLowerCase();

      // 定义所有允许的图片和视频后缀
      const imageExtensions = ['jpg', 'jpeg', 'png', 'gif', 'bmp', 'webp'];
      const videoExtensions = ['mp4', 'webm', 'ogg'];

      let isAllowedType = false; // 初始化为 false

      // 根据 allowedTypes 的内容判断允许的类型
      if (this.allowedTypes.includes('image')) {
        isAllowedType = isAllowedType || imageExtensions.includes(fileExtension); // 逻辑或
      }
      if (this.allowedTypes.includes('video')) {
        isAllowedType = isAllowedType || videoExtensions.includes(fileExtension); // 逻辑或
      }

      // 如果没有指定 allowedTypes，允许所有类型
      if (this.allowedTypes.length === 0) {
        isAllowedType = true;
      }

      const isLtSize = file.size / 1024 < 500;

      if (!isAllowedType) {
        this.$message.error('文件类型不被允许');
        return false;
      }

      return true;
    },
    // 上传文件
    handleAvatarSuccess(file) {
      let formData = new FormData();
      formData.append('file', file.raw);
      this.loading = true;
      this.$request
        .post('/collective/file/upload', formData)
        .then((res) => {
          console.log('---------', res);
          this.loading = false;
          if (file.raw.type.indexOf('image') > -1) {
            this.imgs.push({
              url: URL.createObjectURL(file.raw),
              type: 'image',
            });
          } else if (file.raw.type.indexOf('video') > -1) {
            this.imgs.push({
              url: URL.createObjectURL(file.raw),
              type: 'video',
            });
          } else {
            this.imgs.push({ url: file.name, name: '' });
          }
          this.$emit('fileurl', {
            res: res,
            title: file.raw.name,
          });
        })
        .catch((res) => {
          this.loading = false;
          console.log('---------imgs', this.imgs);
        });
    },
    onFileChange(file) {
      if (this.beforeUpload(file)) {
        this.handleAvatarSuccess(file);
      }
    },
    onError(err, file, fileList) {
      console.log('---------err', err);
      console.log('---------file', file);
      console.log('---------fileList', fileList);
    },
  },
};
</script>
<style lang="less">
.new-front-uploader {
  display: flex;
  .el-upload-list {
    display: flex;
    align-items: center;
  }
  .upload-btn {
    min-width: 104px;
    height: 35px;
    opacity: 1;
    border-radius: 4px;
    background-color: transparent;
    border: 1px solid rgba(27, 112, 255, 1);
    font-size: 14px;
    font-weight: 400;
    color: rgba(27, 112, 255, 1);
  }
  .img-list {
    display: flex;
    .img-item {
      margin: 0 5px;
      i {
        margin-left: 5px;
        cursor: pointer;
      }
    }
  }
}
</style>
